// A student audit program is addressed by (auditProgramID, auditDegreeID, revTermCalendarID) for one student.

/** Keys of a row from GET audit-programs/{studentUID} (CAMS_StudentAuditProgram_View, ID-suffixed names). */
export const programKeysOf = (row) =>
    row
        ? {
              auditProgramID: row.auditProgramID,
              auditDegreeID: row.auditDegreeID,
              revTermCalendarID: row.revTermCalendarID,
          }
        : null;

export const programKeyText = (keys) => (keys ? `${keys.auditProgramID}-${keys.auditDegreeID}-${keys.revTermCalendarID}` : '');

export const sameProgramKeys = (a, b) => Boolean(a && b) && programKeyText(a) === programKeyText(b);
